/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Container, Grid } from '@tishman/components';
import React from 'react';

import {
  selectCheckoutCartSelectionsGroupedByDateTime,
  selectCheckoutCartTotals,
  selectFlow,
  useAppSelector,
} from '../../../store';

import { OrderSummaryViva } from './order-summary-viva';
import { PaymentFormViva } from './payment-form-viva';

export interface CheckoutLoaderHandlers {
  setShowLoadingModal: (show: boolean) => void;
  setIsCheckoutSubmitting: (submitting: boolean) => void;
}
export type PaymentComponentVivaProps = CheckoutLoaderHandlers;

export function PaymentComponentViva({
  setShowLoadingModal,
  setIsCheckoutSubmitting,
}: PaymentComponentVivaProps): React.JSX.Element {
  const flow = useAppSelector(selectFlow);
  const cartSelectionsByDate = useAppSelector(
    selectCheckoutCartSelectionsGroupedByDateTime,
  );

  const totals = useAppSelector(selectCheckoutCartTotals);

  const gridStyles = {
    gridTemplateColumns: ['1fr', '1fr', '1fr', '286px 1fr'],
  };

  return (
    <Container
      sx={{
        py: [48, 72],
      }}
    >
      <Grid gap={72} sx={gridStyles}>
        <OrderSummaryViva
          cartSelectionsByDate={cartSelectionsByDate}
          flow={flow}
          isLoading={false}
          totals={totals}
        />
        <PaymentFormViva
          setIsCheckoutSubmitting={setIsCheckoutSubmitting}
          setShowLoadingModal={setShowLoadingModal}
        />
      </Grid>
    </Container>
  );
}
